import Vue from 'vue'

export const themeConfig = new Vue();
